import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { DeviceMgtList, DeviceSettingList, DeviceSettingFilter } from '../../../my-features/device-mgt/device-mgt.model';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as fromFeature from '../../../my-features';
import { Confirm_button } from '../../../../environments/environment';
import { Region } from '../../../my-features/region/region.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { map, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { UpdateInfoModel } from '../../../my-features/updateInfo/update-info.model';
import {  updateInfoType } from '../../../shareModel';
import { PickList } from 'primeng/picklist';
import { Location } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-device-transfer',
  templateUrl: './device-transfer.component.html',
  styleUrls: ['./device-transfer.component.css']
})
export class DeviceTransferComponent implements OnInit, OnDestroy {
  @ViewChild('pickList', { static: false }) pickList: PickList;
  IsSuperAdmin = false;
  Confirm_button = Confirm_button;
  sourceList: any[] = [];
  targetList: any[] = [];
  sourceList_company: any;
  targetList_company: any;
  sourceCompanyOptions: any[] = [];
  targetCompanyOptions: any[] = [];
  filterParam: DeviceSettingFilter = { RegionId: -1 };
  filterTargetParam: DeviceSettingFilter = { RegionId: -1 };
  region: Region[];
  regionLoaded: boolean;
  isMsp: boolean;
  targetDropdownDisabled: boolean;
  private componentDestroyed = new Subject();
  transferDeviceConfirmDialog = false;
  UpdateInfoParam = {} as UpdateInfoModel;
  reloadgateway = false;
  checkAuthRegion = false;
  gatewayIds = [];
  gatewayDeviceList: number[];
  constructor(private ngxService: NgxUiLoaderService, private store: Store<fromStore.State>, private router: Router,
    private messageService: MessageService, private translateService: TranslateService,
    private location: Location,) {
    const deviceMgtParam = { syncAccountsInfo: false };
    this.store.dispatch(new fromFeature.GetDeviceMgtLists(deviceMgtParam));
    // Get All Region
    this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.length > 0) {
        this.region = res;
        if (!this.regionLoaded) {
          this.regionLoaded = true;
        }
      }
    });

    // Get User Authority
    combineLatest(this.store.select(fromStore.getCurrentUser), this.store.select(fromStore.getDeviceMgtListFilter))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([user, regionFiler]) => {
        if (!user.isLoading && user.isLoaded) {
          this.IsSuperAdmin = user.authority == 2;
          this.isMsp = user.isMsp;
          if (regionFiler.RegionIdOption <= 0) {
            this.filterParam = {
              ...this.filterParam,
              RegionId: user.RegionId,
            };
          } else {
            this.filterParam = {
              ...this.filterParam,
              RegionId: regionFiler.RegionIdOption,
            };
          }
          if (user.isMsp) {
            if ( user.AuthorityRegion !== undefined && user.AuthorityRegion.length > 0) {
              this.checkAuthRegion = true;
            } else {
              this.checkAuthRegion = false;
            }
          } else {
            this.checkAuthRegion = true;
          }
          if (!this.reloadgateway && this.checkAuthRegion) {
            const params = user.isMsp ? {
              otp: '',
              RegionIds: user.AuthorityRegion
            } : {
              otp: ''
            }
            this.store.dispatch(new fromFeature.ReadGatewayList(params));
            this.reloadgateway = true;
          }
        }
      });

    // Get Gateway List
    this.store
      .select(fromStore.ReadGateWayList)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((gateway) => {
      if (!gateway.Loading && gateway.Loaded) {
        if (gateway.entities !== undefined && gateway.entities !== null && Array.isArray(gateway.entities) && gateway.entities.length > 0) {
          // gateway全部刪除
          const gatewayIds = [];
          gateway.entities.forEach((g) => {
            gatewayIds.push(g.Id);
          })
          this.reloadDeviceList(gatewayIds);
        } else {
          this.gatewayDeviceList = [];
        }
      }
    });

    // Get company options
    this.store.pipe(select(fromStore.getRegionsOptions)).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (this.region) {
        const filteredItems = this.region.filter(item => item.IsMsp === true);
        const matchingItems = res.filter(resItem => filteredItems.some(filterItem => filterItem.RegionName === resItem.label));
        this.sourceCompanyOptions = matchingItems;
        this.targetCompanyOptions = matchingItems;
        const sourcefilteredData = this.sourceCompanyOptions.filter(item => item.value === this.filterParam.RegionId);
        if (sourcefilteredData.length > 0) {
          this.sourceList_company = sourcefilteredData[0];
        }
      }
    });

    // Get Device Mgt List
    combineLatest(this.store.select(fromStore.getDeviceMgtList), this.store.select(fromStore.ReadGateWayDeviceList))
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe(([res, regionFiler]) => {
      if (res && Array.isArray(res)) {
        if (!regionFiler.Loading && regionFiler.Loaded && regionFiler.entities !== undefined && Array.isArray(regionFiler.entities)) {
          const dcodeList = [];
          if (regionFiler.entities.length > 0) {
            for (const i in regionFiler.entities) {
              const info = regionFiler.entities[i];
              if (info !== undefined && info.DeviceList !== undefined && info.DeviceList.length > 0) {
                info.DeviceList.map(d => {
                  dcodeList.push(d.dcode);
                })
              }
            }
            this.gatewayDeviceList = dcodeList;
          }
        }
        if (this.sourceList_company === undefined || Object.keys(this.sourceList_company).length === 0) {
          this.sourceList = [];
        } else {
          if ( this.gatewayDeviceList !== undefined && this.gatewayDeviceList.length > 0 ) {
            this.sourceList = res.filter((s) => !this.gatewayDeviceList.includes(s.dcode));
          } else {
            this.sourceList = res;
          }
        }
      }
    });

    // Get Loading Status
    this.store.pipe(select(fromStore.getDeviceMgtListState)).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loaded && res.Loading) {
        this.ngxService.start();
      } else if (res.Loaded && !res.Loading) {
        this.ngxService.stop();
      }
    });

    // Get Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.type === updateInfoType.TranslateMspDevice && !res.isLoading && res.isLoaded) {
        if (res.isSaved) {
          this.messageService.add({ severity: 'success', summary: 'Transfer Device successfully!' });
        } else {
          const err = 'Transfer Device Fail';
          this.messageService.add({ severity: 'error', summary: err });
        }
        this.resetUpdateInfoState();
        this.ngxService.stop();
        this.filterChange();
      }
    });

  }

  ngOnInit() {
    this.sourceList_company = {};
    this.targetList_company = {};
    this.targetDropdownDisabled = true;
    this.filterChange();
  }

  filterChange() {
    const regionInfo = this.region !== undefined ? this.region.find((r) => r.Id === this.filterParam.RegionId) : undefined;
    if (regionInfo !== undefined && regionInfo.IsMsp) {
      const sourcefilteredData = this.sourceCompanyOptions.filter(item => item.value === this.filterParam.RegionId);
      if (sourcefilteredData.length > 0) {
        this.sourceList_company = sourcefilteredData[0];
      }
      this.targetDropdownDisabled = false;
    }
    this.store.dispatch(new fromFeature.SelectDeviceMgtListFilters({ ...this.filterParam }));
    this.targetList = [];
    // PrimeNG 20：filter 改由 Listbox 內建處理；換公司時清掉舊搜尋條件
    if (this.pickList?.resetFilter) {
      this.pickList.resetFilter();
    }
  }

  selectTargetCompany() {
    const regionInfo = this.region !== undefined ? this.region.find((r) => r.Id === this.filterTargetParam.RegionId) : undefined;
    if (regionInfo !== undefined && regionInfo.IsMsp) {
      const targetfilteredData = this.targetCompanyOptions.filter(item => item.value === this.filterTargetParam.RegionId);
      this.targetList_company = targetfilteredData[0];
    }
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.unsubscribe();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

  comfirmTransfer() {
    this.transferDeviceConfirmDialog = true;
  }

  saveTransfer() {
    const dcodes = [];
    this.targetList.map((i) => {
      dcodes.push(i.dcode);
    });
    const param = {
      otp : '',
      dcodes : dcodes,
      SourceRegionId: this.sourceList_company.value,
      RegionId: this.targetList_company.value
    };
    this.store.dispatch(new fromFeature.TranslateMspDevice(param));
    this.sourceList = this.sourceList;
    this.targetList = [];
    this.transferDeviceConfirmDialog = false;
  }

  backClicked() {
    if (this.isMsp) {
      this.location.back();
    } else {
      this.router.navigate(['/management/device']);
    }
  }

  reloadDeviceList(gatewayIds) {
      if (gatewayIds !== undefined && gatewayIds.length > 0) {
        const param = {
          otp: '',
          GatewayList: gatewayIds
        }
        this.store.dispatch(new fromFeature.ReadGatewayDeviceList(param));
      }
    }
}
